import { render, staticRenderFns } from "./DashBoardSale.vue?vue&type=template&id=1d09a060"
import script from "./DashBoardSale.vue?vue&type=script&lang=js"
export * from "./DashBoardSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports